import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import SponsorRelatedContentBanner from "core/components/SponsorRelatedContentBanner";

const VIDEO = "VIDEO";
const STREAM = "STREAM";
const CHANNEL = "CHANNEL";

const VARIANT_SX = {
  sidebar: {
    flexShrink: 0,
    px: 1.5,
    pb: 2,
  },
  mobile: {
    mt: { xs: 1.5, sm: 2 },
    px: { xs: 1.875, sm: 2 },
    pb: 2,
  },
};

const HIDDEN_SX = {
  sidebar: {
    display: "none",
    height: 0,
    overflow: "hidden",
    p: 0,
    m: 0,
    flexShrink: 0,
  },
  mobile: {
    height: 0,
    overflow: "hidden",
    mt: { xs: 1.5, sm: 2 },
    p: 0,
    m: 0,
    flexShrink: 0,
  },
};

export default function RelatedContentBannerSlot({
  contentId,
  rightholderId,
  place,
  variant,
}) {
  const [visible, setVisible] = useState(false);

  const onReady = useCallback(() => {
    setVisible(true);
  }, []);

  const onNotFound = useCallback(() => {
    setVisible(false);
  }, []);

  return (
    <Box sx={visible ? VARIANT_SX[variant] : HIDDEN_SX[variant]}>
      <SponsorRelatedContentBanner
        contentId={contentId}
        rightholderId={rightholderId}
        place={place}
        onReady={onReady}
        onNotFound={onNotFound}
      />
    </Box>
  );
}

RelatedContentBannerSlot.propTypes = {
  contentId: PropTypes.string.isRequired,
  rightholderId: PropTypes.string.isRequired,
  place: PropTypes.oneOf([VIDEO, STREAM, CHANNEL]).isRequired,
  variant: PropTypes.oneOf(["sidebar", "mobile"]).isRequired,
};
